import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
// import { Observable, Subject, merge } from 'rxjs';
// import { isNullOrUndefined } from 'util';
import { tVendorModel } from '../models/tVendorModel';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';



@Injectable({
    providedIn: 'root'
  })
  export class tVendorService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;
    readonly pathName = '/tVendorModels';

    // private infiniteStream$: Observable<any> = new Subject<void>().asObservable();

    // private data: any;


    // public addData$: Observable<tVendorModel> = merge(
    //   this
    //     .http
    //     .post(this.baseurl + this.pathName + '/' + 'Formatted', this.data)
    //     ,
    //   this.infiniteStream$
    // ).pipe(shareReplay(1));


    // addData(inputdata: tVendorModel): Observable<tVendorModel> {

    //   this.data = inputdata;
    //   return this.addData$;
    // }

    addData(data: tVendorModel){
      return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted', data).pipe(shareReplay(1));
    }

    getAllData(){
      return this.http.get<tVendorModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }

    getDataById(vendorCode: string){
      return this.http.get<tVendorModel>(this.baseurl + this.pathName + '/' + vendorCode).pipe(shareReplay(1));
    }

    

    deleteData(data: tVendorModel){
      return this.http.delete(this.baseurl + this.pathName + '/' + 'Formatted' + '/' + data.vendorCode).pipe(shareReplay(1));
      // return this.http.delete(this.baseurl + this.pathName + '/' + data.vendorCode);
    }

    updateData(data: tVendorModel){
      console.log();
      // data.lastModifyLoginName = "2";
      return this.http.put(this.baseurl + this.pathName  + '/' + 'Formatted' + '/' + data.vendorCode, data).pipe(shareReplay(1));
    }




  
  
















    // private messageSource = new BehaviorSubject('default message');
    // currentMessage = this.messageSource.asObservable();

    // private selected_mediCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediCode = this.selected_mediCode_Source.asObservable();

    // private selected_mediCateCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediCateCode = this.selected_mediCateCode_Source.asObservable();

    // private selected_mediName_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediName = this.selected_mediName_Source.asObservable();

    // private selected_mediNameEng_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediNameEng = this.selected_mediNameEng_Source.asObservable();

    // private selected_mediBarCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediBarCode = this.selected_mediBarCode_Source.asObservable();



    // changeMessage(systemMedicineSetting: tVendorModel) {

    //   let mediCodeStr = '';
    //   let mediCateCodeStr = '';
    //   let mediNameStr = '';
    //   let mediNameEngStr = '';
    //   let mediBarCodeStr = '';

    //   if (!isNullOrUndefined(systemMedicineSetting.mediCode)) {
    //     mediCodeStr = systemMedicineSetting.mediCode.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediCateCode)) {
    //     mediCateCodeStr = systemMedicineSetting.mediCateCode.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediName)) {
    //     mediNameStr = systemMedicineSetting.mediName.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediNameEng)) {
    //     mediNameEngStr = systemMedicineSetting.mediNameEng.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediBarCode)) {
    //     mediBarCodeStr = systemMedicineSetting.mediBarCode.toString();
    //   }


    //   this.selected_mediCode_Source.next(mediCodeStr);
    //   this.selected_mediCateCode_Source.next(mediCateCodeStr);
    //   this.selected_mediName_Source.next(mediNameStr);
    //   this.selected_mediNameEng_Source.next(mediNameEngStr);
    //   this.selected_mediBarCode_Source.next(mediBarCodeStr);

    //   // this.messageSource.next(message);
    // }
  }

  